import React from 'react';

const AlertContent: React.FC = ({ children }) => <p>{children}</p>;

export default AlertContent;
